import { render } from "./CreatCampain.vue?vue&type=template&id=1b4dd042"
import script from "./CreatCampain.vue?vue&type=script&lang=js"
export * from "./CreatCampain.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__